import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isSessionValid()) {
      navigate("/login"); // Redirect to login page if session is invalid
    }
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (!isSessionValid()) {
        navigate("/login"); // Redirect to login page if session is invalid
      }
    }, 60 * 1000); // Check every 1 minute (60,000ms)

    // Clean up the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, [navigate]);

  const auth = JSON.parse(localStorage.getItem("loginUser"));
  const loginUserToken = JSON.parse(localStorage.getItem("loginUserToken"));

  const isSessionValid = () => {
    const loginTime = localStorage.getItem("loginTime");
    if (loginTime > new Date().getTime()) {
      return true;
    }
    localStorage.clear();
    return false;
  };

  // If authenticated, render child routes
  return auth && loginUserToken ? <Outlet /> : <Navigate to="/login" />;
};

export default AuthProvider;
